import { PropsWithChildren } from 'react'
import Styles from './Account.module.scss'

export const AccountListItem = ({ children }: PropsWithChildren) => <li className={Styles.linkedAccount}>{children}</li>
